/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import VideoJS from '@components/videojs/VideoJS';
import { jsBridge } from '@src/utils/js-bridge';
import { ContentBlockFragment, Mp4VideoFragment } from '@graphqlTypes/sitecore';
// import { NewDetailKolFragment } from '@src/common/kol-basic-data';
import { withBasePath } from '@src/common/path-convert';
import videojs from 'video.js';
import { removeflashUrl, withSitPath } from '@src/utils/util';
import { nonPageTracker } from '@src/adobe-launch/data-layer-provider';
import { TrackingEvent } from '@src/adobe-launch/types';
import { convertArticleInfo } from '@src/hooks/tracker/use-article-tracker';

/** 未来可能要区分mp4和直播的逻辑及播放器插件更换，暂时copy了份一样的组件使用。
 * 此组件仅用于处理mp4播放逻辑
 */
export const Mp4Video = ({
    content,
    contentBlock,
}: {
    content: Mp4VideoFragment;
    contentBlock: ContentBlockFragment;
}) => {
    // console.log('Mp4Videocontent----', content);
    // console.log('contentBlock--**********--', contentBlock);
    const playerRef = React.useRef(null);
    const videoJsOptions = {
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        autoplay: content.videoAutoplay?.boolValue,
        controls: true,
        disablePictureInPicture: true,
        responsive: true,
        fluid: true,
        fill: true,
        preload: 'metadata',
        poster: content.videoPoster?.src || '',
        sources: [
            {
                src: content.videoURL?.value,
                type: 'video/mp4',
                // type: typeVal(content.liveStreamingSource.value),
            },
        ],
    };

    const handlePlayerReady = (player: any) => {
        playerRef.current = player;
        const storedID = sessionStorage.getItem('playerId') ?? '[]';
        const getID = Array.from(new Set(JSON.parse(storedID)));
        getID.push(player.id());
        sessionStorage.setItem('playerId', JSON.stringify(Array.from(new Set(getID))));

        const storedLiveID = sessionStorage.getItem('playerLiveId') ?? '[]';
        const getLiveID = Array.from(new Set(JSON.parse(storedLiveID)));
        getLiveID.push(player.id());
        sessionStorage.setItem('playerLiveId', JSON.stringify(Array.from(new Set(getLiveID))));
    };

    const videoNativePlayer = () => {
        console.log('MP4');

        nonPageTracker(
            {
                eventID: TrackingEvent.VideoPlay,
                videoURL: removeflashUrl(content.videoURL?.value ?? ''),
            },
            { article: convertArticleInfo(contentBlock) }
        );
        //Stop all type native video, including MP4 and LiveStream
        const getLivePlayerID = JSON.parse(sessionStorage.getItem('playerLiveId') ?? '[]');
        const getPlayerID = JSON.parse(sessionStorage.getItem('playerId') ?? '[]');
        getPlayerID?.length > 0 &&
            getPlayerID.forEach((i: string) => {
                if (document.getElementById(i)) {
                    const player = videojs(i);
                    // 暂停播放
                    player.pause();
                }
            });

        getLivePlayerID?.length > 0 &&
            getLivePlayerID.forEach((i: string) => {
                if (document.getElementById(i)) {
                    const player = videojs(i);
                    // 暂停播放
                    player.pause();
                }
            });

        jsBridge.appOpenNativePlayer(
            content.videoURL?.value ?? '',
            content.videoTitle?.value ?? '',
            content.videoNativePip?.boolValue ?? false
        );
    };

    useEffect(() => {
        return () => sessionStorage.removeItem('playerId');
    }, []);

    return (
        <>
            {content.videoEnabled?.boolValue && (
                <div>
                    {content.videoNative?.boolValue ? (
                        <div
                            className='bg-[#000] min-h-[242px] md:min-h-[400px] lg:min-h-[514px] relative'
                            onClick={videoNativePlayer}
                            style={{
                                backgroundImage: `url(${withSitPath(
                                    content.videoPoster?.src ?? ''
                                )})`,
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat',
                            }}
                        >
                            {/* <img
                                className='w-full h-full'
                                src={content.videoPoster?.src ?? ''}
                                alt=''
                            /> */}
                            <div className='absolute top-[50%] left-[50%] w-[86px] translate-x-[-50%] translate-y-[-50%]'>
                                <img src={withBasePath('/images/play.svg')} alt='' loading='lazy' />
                            </div>
                        </div>
                    ) : (
                        <VideoJS
                            options={videoJsOptions}
                            onReady={handlePlayerReady}
                            contentBlock={contentBlock}
                        />
                    )}
                </div>
            )}
        </>
    );
};

export default Mp4Video;
